/**
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Logger from './lib/logger';
import ConfigureBundleStep2 from './partials/ConfigureBundleStep2';
import HowItWorksModal from './partials/HowItWorksModal'; // custom element
import ConfiguratorIntersectionalObserver from './partials/ConfiguratorIntersectionalObserver'; // custom element

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Page Configure Bundle Step 2';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
  Logger.info(`${NAME} > init`);
  ConfigureBundleStep2();
}

Logger.info(`${NAME} > loaded`);

// Bootstrap page-specific functionality
init();
